<template>
  <div class="school-new-form">
    <div class="main-title">
      <h2>примерьте на себя обучение</h2>
    </div>

    <div class="school-new-form__block">
      <h3>попробуйте неделю бесплатно</h3>

      <ul>
        <li>более 10 000 материалов на платформе </li>
        <li>интерактивные задания</li>
        <li>записи уроков и мини-лекции к темам</li>
        <li>допольнительные материалы и презентации уроков</li>
      </ul>

      <div class="school-new-form__block_soc">
        <span>или напишите нам в чат</span>
        <div>
          <a
            href="https://wa.me/79686286327"
            target="_blank"
          >
            <img
              src="/v2/school-university/footer/wa.png"
              alt="whatsapp"
            >
          </a>
          <a
            :href="$getTelegramLink($route)"
            target="_blank"
          >
            <img
              src="/v2/school-university/footer/tg.png"
              alt="telegram"
            >
          </a>
          <a
            href="mailto:BPrusakov@synergy.ru"
            target="_blank"
          >
            <img
              src="/v2/school-university/footer/email.png"
              alt="email"
            >
          </a>
        </div>
      </div>
    </div>

    <div class="school-new-form__form">
      <p>получите <b>бесплатный</b> доступ к платформе</p>

      <form-name-field
        ref="nameField"
        v-model="nameInput"
        class="form__input"
        placeholder="как вас зовут?"
        round-border
      />

      <form-phone-field
        ref="phoneField"
        class="form__input form__input_phone"
        :errors-list="submitError"
        :error="validForm === false"
        round-border
        placeholder="ваш номер телефона"
        @updatePhone="phoneInput = $event"
      />

      <form-email-field
        ref="emailField"
        v-model="emailInput"
        class="form__input"
        :submit-error="submitError"
        round-border
        placeholder="ваша почта"
        @clearSubmitError="clearSubmitError"
      />

      <!-- eslint-disable -->
      <span>
          нажимая на кнопку, вы соглашаетесь
          с&nbsp;<nuxt-link
        :to="routeIsArsenal ? '/privacy-arsenal' : '/privacy'"
        target="_blank"
      >условиями обработки данных</nuxt-link>
          в&nbsp;соответствии
          с&nbsp;<nuxt-link
        :to="routeIsArsenal ? '/privacy-arsenal' : '/privacy'"
        target="_blank"
      >политикой конфиденциальности</nuxt-link>
        </span>
      <!-- eslint-enable -->

      <button
        class="m-btn main-programs__form_submit"
        @click="schoolCeny2Page ? submit() : signUp()"
      >
        получить доступ
      </button>
    </div>
  </div>
</template>

<script>
import routeIsArsenal from '~/utils/routeIsArsenal';
import sendLeadMixinConstructor from '~/mixins/sendLeadMixinConstructor';
import FormNameField from '~/components/v2/common/fileds/FormNameField.vue';
import FormEmailField from '~/components/v2/common/fileds/FormEmailField.vue';
import FormPhoneField from '~/components/v2/common/fileds/FormPhoneField.vue';

const sendLeadMixin = sendLeadMixinConstructor({
  needPhone: true,
  needEmail: true,
  needToSendTitle: true,
});

export default {
  name: 'SchoolNewForm',
  components: {
    FormPhoneField,
    FormEmailField,
    FormNameField,
  },
  mixins: [sendLeadMixin],
  props: {
    landCode: {
      type: String,
      default: null,
    },
  },
  computed: {
    routeIsArsenal() {
      return routeIsArsenal(this.$route.name);
    },
    schoolCeny2Page() {
      return this.$route.name === 'online-school-ceny-2'
        || this.$route.name === 'online-school-ceny-dubai'
        || this.$route.name === 'online-school-ceny-3';
    },

    componentLandCode() {
      return this.landCode;
    },
    titleToSend() {
      return 'получите бесплатный доступ к платформе';
    },
  },
};
</script>

<style scoped lang="scss">

  .school-new-form {
    display: grid;
    row-gap: calc(var(--scale) * 40);
    column-gap: calc(var(--scale) * 20);
    grid-template-columns: auto calc(var(--scale) * 445);
    grid-template-rows: auto calc(var(--scale) * 720);

    @include media-down($size-tablet) {
      column-gap: calc(var(--scale) * 6);
      row-gap: calc(var(--scale) * 24);
      grid-template-columns: 1fr 1fr;
    }

    @include media-down($size-mobile) {
      row-gap: calc(var(--scale) * 8);
      grid-template-rows: 1fr calc(var(--scale) * 720) calc(var(--scale) * 516);
      grid-template-columns: 100%;
    }

    .main-title {
      grid-column: 1/3;

      @include media-down($size-mobile) {
        grid-column: 1/2;
        margin-bottom: calc(var(--scale) * 16);
      }
    }

    .school-new-form__block {
      grid-column: 1/2;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: calc(var(--scale) * 32) calc(var(--scale) * 40) calc(var(--scale) * 40);
      background-size: cover;
      background-image: url("/v2/school-new/form/block.webp");

      @include media-down($size-tablet) {
        padding: calc(var(--scale) * 20) calc(var(--scale) * 16) calc(var(--scale) * 40);
        background-image: url("/v2/school-new/form/block-tablet.webp");
      }

      @include media-down($size-mobile) {
        background-image: url("/v2/school-new/form/block-mob.webp");
      }

      h3 {
        max-width: calc(var(--scale) * 716);
        margin-bottom: calc(var(--scale) * 20);

        font-weight: 500;
        font-size: calc(var(--scale) * 112);
        line-height: 90%;
        letter-spacing: -0.06em;
        color: #FFFFFF;

        @include media-down($size-tablet) {
          margin-bottom: calc(var(--scale) * 12);
          max-width: calc(var(--scale) * 257);
          font-size: calc(var(--scale) * 44);
        }
      }

      ul {
        display: flex;
        flex-direction: column;
        gap: calc(var(--scale) * 8);

        @include media-down($size-tablet) {
          max-width: calc(var(--scale) * 344);
          margin-top: calc(var(--scale) * 20);
        }

        li {
          display: flex;
          align-items: center;
          gap: calc(var(--scale) * 12);

          font-weight: 400;
          font-size: calc(var(--scale) * 20);
          line-height: 130%;
          color: #FFFFFF;

          @include media-down($size-tablet) {
            gap: calc(var(--scale) * 8);
            font-size: calc(var(--scale) * 16);
            letter-spacing: -0.02em;
            color: #FFFFFF;
          }

          &:before {
            content: '';
            flex-shrink: 0;
            display: block;
            width: calc(var(--scale) * 12);
            height: calc(var(--scale) * 12);
            background-color: #FFFFFF;
            border-radius: 2px;
          }
        }
      }

      &_soc {
        margin-top: auto;

        @include media-down($size-tablet) {
          display: flex;
          gap: calc(var(--scale) * 12);
          align-items: center;
        }

        span {
          font-weight: 400;
          font-size: 1.25rem;
          line-height: 130%;
          color: #FFFFFF;

          @include media-down($size-tablet) {
            max-width: calc(var(--scale) * 137);
            font-weight: 500;
            font-size: calc(var(--scale) * 18);
            line-height: 120%;
          }
        }

        div {
          margin-top: calc(var(--scale) * 20);
          display: flex;
          gap: calc(var(--scale) * 8);

          @include media-down($size-tablet) {
            margin-top: 0;
          }

          img {
            width: calc(var(--scale) * 80);

            @include media-down($size-tablet) {
              width: calc(var(--scale) * 56);
            }
          }
        }
      }
    }

    .school-new-form__form {
      grid-column: 2/3;
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      padding: calc(var(--scale) * 24) calc(var(--scale) * 20) calc(var(--scale) * 20);
      background-color: #ffffff;
      border-radius: calc(var(--scale) * 60);

      @include media-down($size-tablet) {
        padding: calc(var(--scale) * 20) calc(var(--scale) * 8) calc(var(--scale) * 8);
        border-radius: calc(var(--scale) * 32);
      }

      @include media-down($size-mobile) {
        grid-column: 1/2;
      }

      p {
        margin-bottom: calc(var(--scale) * 30);
        padding-inline: calc(var(--scale) * 10);

        font-weight: 500;
        font-size: calc(var(--scale) * 32);
        line-height: 110%;
        color: #02120F;

        @include media-down($size-tablet) {
          margin-bottom: calc(var(--scale) * 20);
          padding-inline: calc(var(--scale) * 8);
          font-size: calc(var(--scale) * 28);
        }

        b {
          color: #FF5319;
        }
      }

      .form__input {
        width: 100%;
        margin-bottom: calc(var(--scale) * 8);

        @include media-down($size-tablet) {
          padding-inline: calc(var(--scale) * 8);
        }

        &:last-of-type {
          margin-bottom: calc(var(--scale) * 31);

          @include media-down($size-tablet) {
            margin-bottom: calc(var(--scale) * 20);
          }
        }

        ::v-deep(.phone-field__wrap),
        ::v-deep(input) {
          width: 100%;
          height: calc(var(--scale) * 88);
          border: 1px solid #CACACB;

          font-weight: 500;
          font-size: calc(var(--scale) * 26);
          line-height: 120%;
          color: #A7ABAC;

          @include media-down($size-tablet) {
            height: calc(var(--scale) * 68);
            font-size: calc(var(--scale) * 18);
            letter-spacing: -0.02em;
          }

          &::placeholder {
            color: inherit;
          }
        }

        ::v-deep(.phone-field__wrap) {
          border: none;
        }
      }

      span {
        display: block;
        padding-inline: calc(var(--scale) * 10);

        font-weight: 500;
        font-size: calc(var(--scale) * 16);
        line-height: 130%;
        color: #A7ABAC;

        @include media-down($size-tablet) {
          padding-inline: calc(var(--scale) * 8);
          font-size: calc(var(--scale) * 14);
        }

        a {
          text-decoration-line: underline;
          color: #5237E6;
        }
      }

      .m-btn {
        margin-top: auto;
        width: 100%;
        padding: calc(var(--scale) * 44) calc(var(--scale) * 16);
        background-color: #FF5319;
        border-radius: calc(var(--scale) * 40);
        background-blend-mode: soft-light, normal;
        transition: 200ms;

        font-weight: 500;
        font-size: calc(var(--scale) * 32);
        line-height: 110%;
        color: #FFFFFF;

        @include media-down($size-tablet) {
          padding: calc(var(--scale) * 30);
          border-radius: calc(var(--scale) * 24);
          font-size: calc(var(--scale) * 18);
        }

        @media (hover: hover) {
          &:hover {
            background-color: #FF9C12;
          }
        }
      }
    }
  }

</style>
